export const config = {
  dev: {
    API_SERVER: 'https://fi-invosy-api-dev.azurewebsites.net/api',
    //API_SERVER: 'http://localhost:7071/api',
    KVT_IDENTITY_SERVER:
      'https://fi-invosy-identity-dev.azurewebsites.net/loginuser/api',
    IDENTIFICATION_SERVER:
      'https://fi-invosy-identity-dev.azurewebsites.net/registeruser',
    RESONIA_API_SERVER: 'https://res-api.azurewebsites.net/api',
    BUILD_DATE_ENDPOINT: '/meta.json',
    PAYMENTS_API_SERVER: 'https://kvtapiserver.azurewebsites.net/api',
    PAYMENTS_API_PATH_USERS: 'SalPaymentforUsersXXX',
    PAYMENTS_API_PATH_MAIN_ACCOUNT: 'SalDeductionToMainAccountXXX',
    PAYMENTS_API_PATH_SERVICE_ACCOUNT: 'SalServiceToServiceAccountXXX',
    PAYMENTS_API_PATH_ULOSOTTO: 'SalaryUlosottoToUlosottoAccountXXX'
  },

  test: {
    API_SERVER: 'https://fi-invosy-api-test.azurewebsites.net/api',
    //API_SERVER: 'http://localhost:7071/api',
    KVT_IDENTITY_SERVER:
      'https://fi-invosy-identity-test.azurewebsites.net/loginuser/api',

    IDENTIFICATION_SERVER:
      'https://fi-invosy-identity-test.azurewebsites.net/registeruser',
    RESONIA_API_SERVER: 'https://res-api.azurewebsites.net/api',
    BUILD_DATE_ENDPOINT:
      'https://fi-invosy-api-test.azurewebsites.net/api/UiConfig?ConfigName=BuildDate',
    PAYMENTS_API_SERVER: 'https://kvtapiserver.azurewebsites.net/api',
    PAYMENTS_API_PATH_USERS: 'SalPaymentforUsersXXX',
    PAYMENTS_API_PATH_MAIN_ACCOUNT: 'SalDeductionToMainAccountXXX',
    PAYMENTS_API_PATH_SERVICE_ACCOUNT: 'SalServiceToServiceAccountXXX',
    PAYMENTS_API_PATH_ULOSOTTO: 'SalaryUlosottoToUlosottoAccountXXX'
  },

  prod: {
    API_SERVER: 'https://fi-invosy-api.azurewebsites.net/api',
    KVT_IDENTITY_SERVER:
      'https://fi-invosy-identity-server.azurewebsites.net/loginuser/api',
    IDENTIFICATION_SERVER:
      'https://fi-invosy-identity-server.azurewebsites.net/registeruser',
    RESONIA_API_SERVER: 'https://res-api-prod.azurewebsites.net/api',
    BUILD_DATE_ENDPOINT:
      'https://fi-invosy-api.azurewebsites.net/api/UiConfig?ConfigName=BuildDate',
    PAYMENTS_API_SERVER: 'https://autopaymentapi.azurewebsites.net/api',
    PAYMENTS_API_PATH_USERS: 'SalPaymentforUsers',
    PAYMENTS_API_PATH_MAIN_ACCOUNT: 'SalDeductionToMainAccount',
    PAYMENTS_API_PATH_SERVICE_ACCOUNT: 'SalServiceToServiceAccount',
    PAYMENTS_API_PATH_ULOSOTTO: 'SalaryUlosottoToUlosottoAccount'
  }
}
